import React, { Fragment } from 'react'
import { Route } from 'react-router-dom';
import { UserMappingListing, UserMappingAddEdit } from './Pages';

export const UserMapping = ({ match }) => (
    <Fragment>
        <Route exact path={`${match.path}`} component={UserMappingListing} />
        <Route exact path={`${match.path}/AddEdit`} component={UserMappingAddEdit} />
    </Fragment>
)